import { StyledPageContainer } from './PageContainer.styled';

const PageContainer = ({ children }) => {
  return <StyledPageContainer>{children}</StyledPageContainer>;
};

export default PageContainer;
